import axios from "axios";

export const _dev = process.env.NODE_ENV === "development";

const env = process.env.REACT_APP_ENVIROMENT;
const baseUrlDev = process.env.REACT_APP_API_BASE_URL;
const baseUrlTesting = process.env.REACT_APP_API_BASE_URL_TESTING;
const baseUrlProduction = process.env.REACT_APP_API_BASE_URL_PRODUCTION;

const BASE_URL = _dev
  ? baseUrlDev
  : env === "testing"
    ? baseUrlTesting || baseUrlDev
    : baseUrlProduction || baseUrlDev;

const _axios = axios.create({
  baseURL: BASE_URL,
  timeout: 90000,
  withCredentials: true,
  // headers: {
  //   'token': localStorage.getItem('token')
  // }
});

// agrego un interceptor a las respuestas del cliente api...
_axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // si se produjo un error de permisos, redirijo al login
    if (error.response.status === 401) {
      window.location.hash = "/Login";
      return false;
    }

    return Promise.reject(error);
  }
);

_axios
  .get("/api/instalacion/GetTitlePage", {
    params: {
      title: "Title",
    },
  })
  .then((response) => {
    const data = response.data;

    if ("title" in data) {
      document.title = data.title;
    } else {
      console.error('La propiedad "title" no está presente en la respuesta de la API.');
    }
  })
  .catch((error) => {
    // Maneja el error
    console.error("Error al obtener el título:", error);
  });

export default _axios;
